<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-darkgray shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      نرم‌افزار مدیریت ارتباط با مشتری (CRM) و باشگاه مشتریان
                    </h3>

                    <p>
                      مدیریت ارتباط با مشتریان کسب و کار خود را در بالاترین سطح
                      تجربه کنید!
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/management-pana.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <section class="section-tab-product">
        <div class="container-section">
          <tabs :fill="false" class="flex-column">
            <tab-pane key="tab1" class="section-product">
              <template slot="title">
                <h5>
                  CRM
                </h5>
              </template>

              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <p>
                    در دنیای پر رقابت امروز، ارتباط موثر با مشتریان و حفظ رضایت
                    آن‌ها کلید موفقیت هر کسب‌وکاری به شمار می‌آید. نرم‌افزار CRM
                    سرمد، با افتخار راهکاری موثر جهت مدیریت تعاملات کسب و کار
                    شما با مشتریان فعلی و بالقوه خود ارائه می‌دهد. این سیستم به
                    شما کمک می‌کند تا روابط میان سازمان و مشتریان خود را
                    سازماندهی کنید و کسب و کار خود را توسعه دهید.
                  </p>

                  <p>
                    لازمه رشد و توسعه هر کسب و کار، شناخت دقیق منابع سودآوری
                    بازار و تمرکز بر آن‌ها است. نرم افزار CRM برای شما این امکان
                    را فراهم می‌کند تا تمامی فرایندهای گردآوری و نظارت بر جریان
                    داده‌های فروش را با بالاترین دقت و کمترین هزینه مدیریت کنید
                    و از تجزیه و تحلیل این داده‌ها برای رسیدن به اهداف و نیازهای
                    خاص شرکت خود استفاده کنید.
                  </p>
                  <p>
                    این سیستم یکی از ماژول‌های نرم‌افزار جامع مدیریت پروژه
                    ساتراپ است که می‌تواند به تنهایی و یا به همراه سایر امکانات
                    این نرم‌افزار متناسب با نیازهای سازمان شما و به صورت کاملا
                    شخصی سازی شده ارائه شود.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <div class="img-tab">
                    <img src="img/product/Customer.svg" alt="" />
                  </div>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab2" class="section-product">
              <template slot="title">
                <h5>
                  چه کسانی از نرم‌افزار CRM استفاده می‌کنند؟
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <p>
                    نرم‌افزار CRM سرمد، برای شرکت‌ها و کسب و کارها با هر
                    اندازه‌ای مناسب است. این نرم‌افزار به سازمان شما کمک می‌کند
                    تا به آسانی و با دقت بالاتر، تمامی فرایندهای مربوط به ثبت،
                    پیگیری و نظارت بر تعاملات هر مشتری انجام شود.
                  </p>
                  <p>
                    این نرم‌افزار، مجموعه‌ای از ابزار را در اختیار کارکنان شما
                    قرار می‌دهد که برای هر سازمانی که با مشتری تعامل دارد (اعم
                    از B2B و B2C) امکان شناسایی فرصت‌های رشد، بهینه سازی تخصیص
                    منابع، تصمیم گیری مبتنی بر داده، ایجاد مزیت رقابتی و افزایش
                    سودآوری را فراهم می‌کند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <div class="img-tab">
                    <img src="img/product/relationship.svg" alt="" />
                  </div>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab3" class="section-product">
              <template slot="title">
                <h5>
                  مزایای استفاده از نرم‌افزار CRM
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          ذخیره و نگهداری تمامی اطلاعات سازمان در بستری امن و
                          یکپارچه و دسترسی آسان به آن‌ها فارغ از زمان و مکان
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تسهیل تعیین استراتژی و رویکردهای آینده سازمان با بررسی
                          دقیق شکاف‌ها و فرصت‌های موجود
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          امکان سفارشی سازی سیستم بر اساس نیازهای سازمان شما
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          افزایش دقت، سرعت و کیفیت معاملات تجاری با مشتریان
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          بررسی و نظارت فراگیر حرفه‌ای بر تمامی فعالیت‌های
                          سازمان
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تولید و مقایسه انواع گزارش‌های مالی و عملکردی و تجزیه
                          و تحلیل داده‌ها
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          کاهش هزینه‌های عملیاتی از طریق اتوماسیون حداکثری
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت اعطا امتیاز و تسهیلات ویژه به مشتریان خاص
                          سازمان و افزایش رضایت مشتری از طریق باشگاه مشتریان
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          طراحی و رابط کاربری ساده و کاربرپسند
                        </h5>
                      </div>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab4" class="section-product">
              <template slot="title">
                <h5>
                  ‌ماژول‌های نرم افزار CRM سرمد
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>پروفایل مشتری</h6>
                  <p>
                    دسترسی به تمامی اطلاعات و تاریخچه تعاملات هر مشتری در کمترین
                    زمان، شناسایی درخواست‌های پرتکرار مشتریان، تحلیل داده‌های
                    مشتری و تولید انواع گزارش‌ها، همگی از قابلیت‌هایی هستند که
                    در این بخش برای کارکنان شما فراهم می‌شود و امکان پاسخگویی
                    دقیق و درخور به تمامی نیازهای مشتریان شما را میسر می‌سازد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>باشگاه مشتریان</h6>
                  <p>
                    در این بخش می‌توانید انواع پارامترها جهت کسب امتیاز مشتری در
                    باشگاه مشتریان را تعریف نمایید و بر اساس امتیاز کسب شده،
                    مشتریان را دست بندی کنید و انواع تسهیلات و خدمات ویژه را
                    برای دسته‌ای از مشتریان در نظر بگیرید. با اتصال باشگاه
                    مشتریان به فروشگاه آنلاین، نرخ فروش و بازدهی کسب‌وکار خود را
                    به دو چندان افزایش دهید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>انبارداری</h6>
                  <p>
                    بهینه سازی و اتوماسیون حداکثری تمامی فرآیندهای مرتبط با
                    مدیریت و کنترل موجودی‌ها و عملیات انبارداری را با استفاده از
                    ماژول انبارداری تجربه کنید. قابلیت اتصال انبارداری نرم‌افزار
                    به سایر بخش‌های این سیستم مانند مدیریت سفارش‌ها، فروشگاه، خط
                    تولید و... امکان انتقال فراگیر داده‌ها و اطلاعات را برای شما
                    فراهم می‌کنند و هماهنگی بین انبار و سایر بخش‌های سازمان را
                    تسهیل می‌سازد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>گزارش ساز</h6>
                  <p>
                    با توجه به نیاز سازمان خود در لحظه، از هر بخشی از سیستم،
                    گزارش‌های مختلف و متنوع تهیه کرده و از آن‌ها برای مقایسه،
                    عیب یابی و افزایش بهره‌وری سازمان خود استفاده نمایید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>چت سازمانی</h6>
                  <p>
                    در بستری امن به ارسال و دریافت پیام به صورت real-time، ایجاد
                    گروه چت‌ و ارسال و دریافت انواع فایل‌ها بپردازید. امکان
                    برقراری تماس‌های صوتی و تصویری میان کارمندان، جهت برگزاری
                    جلسات با بالاترین کیفیت نیز در این سیستم تعبیه شده است.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>فروشگاه آنلاین</h6>
                  <p>
                    به آسانی و فارغ از محدودیت زمانی و مکانی، کالا و خدمات خود
                    را به مشتریان خود ارائه داده و کسب و کار خود را گسترش دهید.
                    با قابلیت اتصال این فروشگاه به انبارداری این فرصت را برای
                    شما فراهم می‌شود تا بتوانید محصولات خود را به صورت مستقیم و
                    بدون واسطه به دست مشتریان خود برسانید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>دبیرخانه</h6>
                  <p>
                    قابلیت ثبت، اصلاح و ابطال نامه‌های درون سازمانی و میان
                    سازمانی، پیگیری و امضای نامه‌ها، بایگانی نامه‌ها و فرم‌ها و
                    به طور کلی، تمام ابزارهایی که جهت مدیریت نامه‌های سازمان خود
                    احتیاج دارید، در این بخش به طور کامل در اختیارتان قرار خواهد
                    گرفت.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>صدور فاکتورفروش و پیش فاکتور</h6>
                  <p>
                    برای مشتریان خود انواع پیش‌فاکتور و فاکتورهای شخصی‌سازی‌شده
                    صادر کنید و کلیه اسناد و مدارک مربوط به پیش پرداخت و سایر
                    واریزی‌ها در یک مکان آرشیو کنید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مدیریت بازاریابی و پیاده سازی web engagement</h6>
                  <p>
                    ایجاد انواع کمپین های بازاریابی از طریق تماس، پیامک و ایمیل
                    به آسانی امکان پذیر است. همچنین می‌توانید با ردیابی و تجزیه
                    و تحلیل رفتار کاربر، بهترین تجربه شخصی سازی شده را برای
                    مشتریان خود فراهم کنید.
                  </p>
                </b-col>
              </b-row>
            </tab-pane>
          </tabs>
        </div>
      </section>
    </div>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  name: "CRM",
  components: {
    Tabs,
    TabPane,
  },
  data() {
    return {
      showScrollButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
